// dotenv use
import dotenv from "dotenv";
dotenv.config();

import Vue from "vue"
import App from "./App.vue"
import Vuex from "vuex"
import store from "./store"
import router from "./router"
import Meta from 'vue-meta'
import axios, { isAuthenticated, API_URL } from "./helpers/axios"
import vuetify from "./plugins/vuetify"
import "material-design-icons-iconfont/dist/material-design-icons.css"

// import CKEditor from "ckeditor4-vue";
import "animate.css";
// import VueConfetti from "vue-confetti";
import "@babel/polyfill";
import "roboto-fontface/css/roboto/roboto-fontface.css"
import "@fortawesome/fontawesome-free/css/all.css"
// import "vue2-animate/dist/vue2-animate.min.css";
// import "video.js/dist/video-js.css";

import VueSession from "vue-session";
import VueTheMask from "vue-the-mask";

import i18n from "@/locales/i18n";

import webSiteTemplate from "./layouts/webSite/layout";
// import LoginTemplate from "./layouts/login/login";
// import webSystemTemplate from "./layouts/webSystem/layout";


// componente para cargar el mensaje general del sistema
import mensajeSistema from "./components/mensajeSistema";
import confirm from "./components/confirm";
import loading from "./components/loading"
import { Files } from "./functions/files";

// funcion para filtrar y formatear campos de vue
import "@/functions/filters";

import moment from "vue-moment";

//import reload from "./views/reload";
// import inactive from "@/inactive";
// import "@/inactive";

// alert(JSON.stringify(process.env))
import "@/assets/css/global.css";
import "./assets/css/helpers.scss";
///// Plantillas //////

Vue.component("webSite_layout", webSiteTemplate)
// Vue.component("webSystem_layout",  webSystemTemplate)
// Vue.component("login_layout", LoginTemplate)

/////////////////////
// Vue.use(PerfectScrollbar);
/////////////////////
// Vue.use(VueConfetti);

Vue.use(Meta)

Vue.use(VueTheMask)
// Vue.use( filters)

Vue.use(moment)
///// Componentes //////
//  Vue.use(mensajeSistema)
Vue.component("mensajeSistema", mensajeSistema)
Vue.component("confirm", confirm)
Vue.component("loading", loading)

//////////

// Estados globales - response
const states = {
  success: "S",
  warning: "W",
  error: "E",
};
/**
 * component modal confirm
 */
Vue.prototype.$states = states;
Vue.prototype.$Files = Files;
Vue.prototype.$http = axios;

Vue.use(VueSession);
Vue.config.productionTip = false;

// sacando error console todos los componentes mensaje ckeditor
try {
  //Vue.use(CKEditor2);
//   Vue.use(CKEditor);
} catch (error) {
  //console.error(error);
}

//reload time out
// Vue.component("inactive", inactive);

// interceptors axios - validar la sesion mediante token
axios.defaults.headers.post["Content-Type"] = "application/json";
// cors
axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";


// request interceptors
axios.interceptors.request.use(
  async function(config) {
    await isAuthenticated();
    config.headers.Authorization = "Bearer " + sessionStorage.getItem("token");
    config.headers.baseURL = API_URL;
    return config;
  },
  function(error) {
    console.log(error);
    return Promise.reject(error);
  }
);

// response interceptors
axios.interceptors.response.use(
  function(response) {
    if (
      response.data != null &&
      response.data.access !== undefined &&
      !response.data.access
    ) {
      location.href = "./logout";
    }
    return response;
  },
  function(error) {
    console.log("error:", error);
    return Promise.reject(error);
    //return (location.href = "./logout");
  }
);


// comentar y borrar si es necesario //
// PRUEBA DE MATH 2022-02 -06 

// 

// CKEditor
new Vue({
  router,
  Vuex,
  store,
  vuetify,
  axios,

  VueTheMask,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
